import { createServerFn } from "@tanstack/react-start";
import { getRequest, setResponseHeader } from "@tanstack/react-start/server";
import type { AuthUser } from "@myapp/shared";

const API_URL = process.env.VITE_PUBLIC_API_URL ?? "http://localhost:3001";

export const fetchAuthUserServer = createServerFn({ method: "GET" }).handler(
  async () => {
    const request = getRequest();
    const cookie = request.headers.get("cookie");

    try {
      const response = await fetch(`${API_URL}/auth/me`, {
        headers: cookie ? { Cookie: cookie } : {},
      });

      const setCookies = response.headers.getSetCookie();
      if (setCookies.length > 0) {
        setResponseHeader("Set-Cookie", setCookies);
      }

      if (!response.ok) return null;

      const data = (await response.json()) as { user: AuthUser };
      return data.user;
    } catch {
      return null;
    }
  },
);
